module.exports = __webpack_public_path__ + "static/media/StorySectionBg-sm.45fe97a7.jpg";